module.exports = __webpack_public_path__ + "img/ms_b2_pic1.44aee90d.png";